module.exports = __webpack_public_path__ + "static/media/Schiratti1927.a9d54c9e.jpg";